import { acceptHMRUpdate, defineStore } from 'pinia';

interface State {
    isLoggedIn: boolean;
}

export const useAuthStore = defineStore('v3/auth', {
    state: (): State => {
        return {
            isLoggedIn: false,
        };
    },
    persist: {
        storage: sessionStorage,
    },
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
